function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#fff;}.cls-5{isolation:isolate;}.cls-6{fill:#df4f70;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 12.12,
  y1: 93.13,
  x2: 70.41,
  y2: 41.77,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 98)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#772fea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#732ee9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#682de7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#562ae3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3d26de"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 119.46,
  y1: 66.14,
  x2: 6.64,
  y2: 11.27,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 98)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#772fea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#7c30e5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#9a3ac1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#b341a3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#c7478d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#d44c7d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#dc4e73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#df4f70"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 64.87,
  y1: -3.15,
  x2: 64.87,
  y2: 112.62,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 98)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#df4f70"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#e78460"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#eba058"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logo-studio");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M74.86,19.17V81.32a3.51,3.51,0,0,1-5.51,2.89L1.48,36.44a3.51,3.51,0,0,1,0-5.73L27.4,13.47a3.46,3.46,0,0,1,4,.08l10.28,7.3a3,3,0,0,1,.49,4.21,2.67,2.67,0,0,1-.67.63l-8.91,6a2.32,2.32,0,0,0,0,3.79L54.92,51.2Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M54.88,29.61V91.34a3.49,3.49,0,0,0,3.49,3.49,3.53,3.53,0,0,0,2-.64l69.45-46.25a3.5,3.5,0,0,0,.83-4.88,3.63,3.63,0,0,0-.83-.83l-26-18.29a3.14,3.14,0,0,0-3.75.1L88.72,31.66a3,3,0,0,0,.17,4.83l8.79,6.11a2.32,2.32,0,0,1,0,3.79L74.86,61.62Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M70.31,84.88,56.56,75.2a4.38,4.38,0,0,1-1.68-3.82V2.88A2.88,2.88,0,0,1,59.44.55L71.36,8.94a7.52,7.52,0,0,1,3.5,6.74v67.2C74.86,85.22,72.21,86.25,70.31,84.88Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M154.51,81.65l-14.32-38h12.56l8.18,26.87,8.25-26.87h12.13L167,81.65Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M185.68,81.65v-38h12.13v38Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M245.91,81.65h-12.2v-5a13.74,13.74,0,0,1-11.43,5.5c-10.72,0-17.77-7.9-17.77-19.68s7-19.32,17.49-19.32a14.11,14.11,0,0,1,11.71,5.5V29.31h12.2Zm-12.2-18.9c0-5.86-3.39-9.88-8.46-9.88s-8.47,4-8.54,9.88,3.46,9.94,8.54,9.94S233.71,68.6,233.71,62.75Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M296.34,62.82c0,11.57-6.92,19.25-17.57,19.25a14.1,14.1,0,0,1-11.64-5.5v5.08h-12.2V29.31h12.2V48.64a13.88,13.88,0,0,1,11.36-5.43C289.21,43.21,296.34,51,296.34,62.82Zm-12.28-.36c0-5.78-3.45-9.87-8.53-9.87s-8.4,4.09-8.4,9.87,3.46,9.95,8.4,9.95S284.06,68.32,284.06,62.46Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M336.53,56.82V81.65H324.61V77.28c-2.47,3.24-6.49,4.93-11.64,4.93-8.11,0-13.05-4.93-13.05-11.92,0-7.19,5.15-11.42,14.6-11.49h10v-.57c0-3.74-2.47-6-7.41-6a26.72,26.72,0,0,0-11.35,3.17l-3.46-8c5.93-2.75,11.29-4.3,17.63-4.3C330.39,43.07,336.46,48.22,336.53,56.82Zm-12,11.92V65.36h-7.69c-3.67,0-5.5,1.27-5.5,4.09s2,4.51,5.36,4.51c3.82,0,7.06-2.11,7.84-5.22Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M368.55,43.63h13.33L369.82,62.11l12.9,19.54h-14l-6.91-11.92L354,81.65H340.6l13-19.47L341.46,43.63h14l6.35,10.93Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M394.27,70.76l.11-.92a1,1,0,0,1,1-.92h5.51c.54,0,.86.27.81.7l-.11.76c-.32,2.75,2.05,5.13,6.27,5.13,4,0,5.72-2.05,6-4.21.32-2.76-2.21-3.73-7-5.62-5.23-1.94-11.17-4.48-10.31-11.61.81-6.64,6.59-10.69,14.09-10.69,8.05,0,13.18,4.64,12.37,11.61l-.11.54a.92.92,0,0,1-1,.92h-5.51c-.59,0-.86-.22-.81-.54l.06-.54c.32-2.81-1.68-5.46-6.11-5.46-3.34,0-5.4,1.51-5.72,4.05-.32,2.81,1.84,3.78,7.4,5.89,4.53,1.78,10.91,3.89,10,11.23-.81,6.59-6.54,11-14.74,11S393.46,77.61,394.27,70.76Z",
  transform: "translate(0 -0.01)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M455.18,44.73l-.6,4.75a.94.94,0,0,1-1,.92h-9a.36.36,0,0,0-.38.32l-3.67,30a.94.94,0,0,1-1,.92H433.9c-.59,0-.86-.32-.81-.92l3.67-30c.06-.21-.05-.32-.27-.32h-8.8a.71.71,0,0,1-.76-.92l.6-4.75a.92.92,0,0,1,1-.92h25.87C455,43.81,455.23,44.13,455.18,44.73Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M456.58,69.08l3-24.35a.93.93,0,0,1,1-.92h5.61c.6,0,.87.32.81.92l-3,24.41c-.49,3.78,1.67,6.37,5.4,6.37a6.9,6.9,0,0,0,7-6.37l3-24.41a1,1,0,0,1,1-.92H486c.59,0,.86.32.75.92l-3,24.35c-1,7.78-7,13-15.17,13S455.66,76.86,456.58,69.08Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M488.38,80.69l4.43-36a.92.92,0,0,1,1-.92h12.86c7.88,0,12.53,4.54,11.66,11.45l-1.84,14.9c-.8,6.91-6.58,11.45-14.47,11.45H489.14C488.6,81.61,488.33,81.29,488.38,80.69Zm8.37-5.61h6.32c3.24,0,5.67-2.43,6.16-6.16l1.56-12.42c.44-3.73-1.4-6.16-4.75-6.16h-6.26a.31.31,0,0,0-.32.33l-3,24.08C496.48,75,496.54,75.08,496.75,75.08Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M520.73,80.69l4.43-36a.92.92,0,0,1,1-.92h5.62c.59,0,.86.32.75.92l-4.37,36a1,1,0,0,1-1,.92h-5.61C521,81.61,520.68,81.29,520.73,80.69Z",
  transform: "translate(0 -0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M535.26,68.49l1.4-11.56A15,15,0,0,1,552.1,43.38c8.32,0,13.18,5.45,12.15,13.55l-1.4,11.56c-1,8.21-7.18,13.71-15.5,13.71S534.23,76.7,535.26,68.49Zm20.19.27,1.46-11.88c.49-4.21-1.73-7-5.62-7s-6.69,2.76-7.23,7L542.6,68.76c-.49,4.16,1.73,6.91,5.56,6.91S554.91,72.92,555.45,68.76Z",
  transform: "translate(0 -0.01)"
})))));

var SvgLogoStudio = function SvgLogoStudio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 564.39 94.82",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoStudio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-studio.7b81c98a.svg";
export { ForwardRef as ReactComponent };